// LoadingSpinner.js
import React from 'react';

const LoadingSpinner = () => {
  return (
    <div className="spinner-container d-flex justify-content-center my-5">
      <div className="loading-spinner"></div>
    </div>
  );
};

export default LoadingSpinner;
